import styles from "./Billing.module.scss";
import useAppSelector from "../../../hooks/useAppSelector";
import React from "react";
import { useTranslation } from "react-i18next";
import PaymentMethodEmpty from "../../../components/shared/PaymentMethodEmpty/PaymentMethodEmpty";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../../components/ui/CustomButton/CustomButton";

const Billing = () => {
  const { defaultPaymentMethod } = useAppSelector((state) => state.userPaymentMethodsSlice);
  const { t } = useTranslation();
  const navigate = useNavigate();

  if (!defaultPaymentMethod) {
    return (
      <div className={styles.container}>
        <h2 className={styles.title}>{t("BillingInformation")}</h2>
        <PaymentMethodEmpty />
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>{t("BillingInformation")}</h2>
      <div className={styles.wrapper}>
        <div className={styles.item}>
          <h3 className={styles.subtitle}>{t("CurrentBilling")}</h3>
          <p className={styles.text}>{t("CreditCard")}</p>
          <p className={styles.text}>{defaultPaymentMethod.nameOnCard}</p>
          <p className={styles.text}>•••• •••• •••• {defaultPaymentMethod.last4}</p>
          {/*<p className={styles.text}>{viewExpDateForCard(defaultPaymentMethod.expMonth, defaultPaymentMethod.expYear)}</p>*/}
        </div>
        {/*{(defaultPaymentMethod.address1 || defaultPaymentMethod.address2 || defaultPaymentMethod.city || defaultPaymentMethod.country) && (*/}
        {/*    <div className={styles.item}>*/}
        {/*        <h3 className={styles.subtitle}>{t("BillingAddress")}</h3>*/}
        {/*        <p className={styles.text}>{defaultPaymentMethod.address1}</p>*/}
        {/*        <p className={styles.text}>{defaultPaymentMethod.address2}</p>*/}
        {/*        <p className={styles.text}>{defaultPaymentMethod.city}</p>*/}
        {/*        {*/}
        {/*            defaultPaymentMethod.country && (*/}
        {/*                <p className={styles.text}>{countryName(defaultPaymentMethod.country)}</p>*/}
        {/*            )*/}
        {/*        }*/}
        {/*    </div>*/}
        {/*)}*/}
      </div>
      <div className={styles.btnWrapper}>
        <CustomButton
          text={t("SeeAllCards")}
          type={"button"}
          typeStyle={"fill"}
          functionOnClick={() => navigate("/settings/billing/cards")}
        />
      </div>
      {/*<Link className={styles.link} to={"/settings/billing/cards"}>{t("SeeAllCards")}</Link>*/}
    </div>
  );
};

export default Billing;
